import {Component, inject} from '@angular/core';
import {MessageService} from '../services/message-service';
import {NgClass} from '@angular/common';

@Component({
  selector: 'dm-message-list',
  imports: [
    NgClass
  ],
  templateUrl: './message-list.html',
  styleUrl: './message-list.scss',
})
export class MessageList {
  messageService: MessageService = inject(MessageService);
}
